import React from 'react';
import { Avatar } from 'primereact/avatar';
import { Divider } from 'primereact/divider';

/**
 * Get initials from student name
 */
const getInitials = (firstName = '', lastName = '') => {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
};

/**
 * StudentSidebar Component
 * 
 * Displays student profile information in left sidebar including:
 * - Profile picture/avatar with initials
 * - Student name and enrollment details
 * - School and board information
 * - Student joined date
 * - Active status indicator
 */
export const StudentSidebar = ({ studentData }) => {
    const initials = getInitials(studentData?.firstName, studentData?.lastName);

    return (
        <div className="student-sidebar">
            <div className="student-avatar-section">
                {studentData?.profilePicUrl ? (
                    <Avatar
                        image={studentData.profilePicUrl}
                        size="xlarge"
                        shape="circle"
                        className="student-avatar"
                        style={{
                            width: '120px',
                            height: '120px'
                        }}
                    />
                ) : (
                    <Avatar
                        label={initials}
                        size="xlarge"
                        shape="circle"
                        className="student-avatar"
                        style={{
                            width: '120px',
                            height: '120px',
                            fontSize: '2.5rem',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: '#fff'
                        }}
                    />
                )}
            </div>

            <div className="student-name-section">
                <h2>{studentData?.firstName || ''} {studentData?.lastName || ''}</h2>
                <p className="enrollment-id">({studentData?.enrollmentId || 'N/A'})</p>
                <p className="class-badge">{studentData?.class || 'N/A'}</p>
            </div>

            <Divider />

            <div className="school-info">
                <div className="info-row">
                    <i className="pi pi-building"></i>
                    <span>{studentData?.branchName || studentData?.school || 'N/A'}</span>
                </div>
            </div>

            <p className="status-badgee">
                {studentData?.boardName || 'N/A'}
            </p>

            <Divider />

            <div className="joined-info">
                <p className="label">Student Joined in:</p>
                <p className="value">{studentData?.studentJoinedIn || 'N/A'}</p>
            </div>

            <Divider />

            <div className="active-status">
                <i className="pi pi-circle-fill" style={{ color: '#268900', fontSize: '0.5rem' }}></i>
                <span>Active</span>
            </div>
        </div>
    );
};

export default StudentSidebar;
